import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AttachmentIcon from '@mui/icons-material/Attachment';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import HandshakeIcon from '@mui/icons-material/Handshake';
import HistoryIcon from '@mui/icons-material/History';
import InsightsIcon from '@mui/icons-material/Insights';
import LayersIcon from '@mui/icons-material/Layers';
import PaymentsIcon from '@mui/icons-material/Payments';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import PieChartOutlineIcon from '@mui/icons-material/PieChartOutline';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SpeakerNotesOutlinedIcon from '@mui/icons-material/SpeakerNotesOutlined';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';
import TimelineIcon from '@mui/icons-material/Timeline';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import { buildTabMaps, SideTabSection } from '../../components/SideTabs';

/**
 * Sixteen tabs do not scan as a flat list, so they are grouped by what an admin
 * is actually doing: identity, money, compliance, then audit trail.
 * Values and params are unchanged from the previous horizontal tab strip.
 */
export const userTabSections: SideTabSection[] = [
  {
    title: 'Profile',
    tabs: [
      { value: '1', param: 'general', label: 'General', IconComponent: AccountBoxIcon },
      { value: '2', param: 'kyc', label: 'KYC', IconComponent: PersonSearchIcon },
      { value: '6', param: 'attachments', label: 'Attachments', IconComponent: AttachmentIcon },
      { value: '7', param: 'surveyResults', label: 'Survey Results', IconComponent: FactCheckIcon },
      { value: '8', param: 'signAgreements', label: 'Sign Agreements', IconComponent: HandshakeIcon },
    ],
  },
  {
    title: 'Finance',
    tabs: [
      { value: '3', param: 'bankInfo', label: 'Bank Info', IconComponent: AccountBalanceIcon },
      { value: '16', param: 'subscription', label: 'Subscription', IconComponent: SubscriptionsIcon },
      { value: '4', param: 'ownedShares', label: 'Owned Shares', IconComponent: PieChartOutlineIcon },
      { value: '5', param: 'fees', label: 'Fees', IconComponent: ReceiptLongIcon },
      { value: '12', param: 'cashLedger', label: 'Cash Ledger', IconComponent: PaymentsIcon },
      { value: '13', param: 'unitsLedger', label: 'Units Ledger', IconComponent: LayersIcon },
    ],
  },
  {
    title: 'Compliance',
    tabs: [
      { value: '10', param: 'worldCheck', label: 'World Check', IconComponent: TravelExploreIcon },
      { value: '11', param: 'alpaca', label: 'Alpaca', IconComponent: InsightsIcon },
    ],
  },
  {
    title: 'Activity',
    tabs: [
      { value: '9', param: 'history', label: 'History', IconComponent: HistoryIcon },
      { value: '14', param: 'timeline', label: 'Timeline', IconComponent: TimelineIcon },
      { value: '15', param: 'notes', label: 'Notes', IconComponent: SpeakerNotesOutlinedIcon },
    ],
  },
];

export const DEFAULT_TAB_VALUE = '1';

/** `?tab=` param <-> panel value, derived from the sections above. */
export const {
  tabs: userTabs,
  mapTabParamToValue,
  mapTabValueToTabParam,
} = buildTabMaps(userTabSections, DEFAULT_TAB_VALUE);
